import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { Box, ThemeProvider, createTheme } from '@mui/material';

import { v2ThemeOptions } from '../../theme/muiThemeV2';
import { Spinner } from '../../ui/Spinner';
import { GenericHeaderV2 } from './GenericHeaderV2';

// 배럴(@/pages/v2/cart)은 지연 로드되는 장바구니 페이지까지 끌어오므로 파일을 직접 가져온다
import { CartDownloadWatcherSection } from '@/pages/v2/cart/sections/CartDownloadWatcherSection';

/**
 * v2 공용 레이아웃 — 프로토타입(index.html) 방식의 상단 헤더 nav 구조.
 *
 * v2 전용 테마 적용:
 * root(App.tsx)의 inbody 베이스 테마(브레이크포인트 등)는 함수형 ThemeProvider로 상속하되,
 * 그 위에 v2 디자인(버건디 팔레트·폰트)을 병합한다. → v1의 커스텀 테마와 분리.
 *
 * 장바구니 ZIP 작업 감시자도 여기 한 번 둔다 — 장바구니를 벗어나도 다운로드가 이어진다.
 */
export const GenericLayoutV2 = () => {
  return (
    <ThemeProvider
      theme={(outerTheme) => createTheme(outerTheme, v2ThemeOptions)}
    >
      <Box
        id="generic-layout-v2"
        display="flex"
        flexDirection="column"
        sx={{ height: '100dvh' }}
      >
        <GenericHeaderV2 />
        <CartDownloadWatcherSection />

        <Box component="main" flexGrow={1} sx={{ overflow: 'auto' }}>
          <Suspense fallback={<Spinner display={true} />}>
            <Outlet />
          </Suspense>
        </Box>
      </Box>
    </ThemeProvider>
  );
};
